import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";

import { SOCIAL_LINKS } from "@/utils/const";

const Bottom = () => {
  const router = useRouter();
  const isDisclosurePage = router.pathname === "/disclosure";

  return (
    <>
      <div
        className="bottom-zone"
        style={{
          backgroundColor: "#191919",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="section-container flex flex-col items-center bottom-link-over text-white">
          <div className="flex top-section">
            <div className="left-section flex shrink-0">
              <div className="flex flex-col bottom-col">
                <p className="section-title">About</p>
                <Link href={"/about"} className="section-link">
                  Our story
                </Link>
                <Link href={"/contact"} className="section-link">
                  Contact us
                </Link>
                {isDisclosurePage && (
                  <Link href={"/friends"} className="section-link">
                    Friends of Plush
                  </Link>
                )}
              </div>
              <div className="flex flex-col bottom-col">
                <p className="section-title">Policy</p>
                <Link href={"/terms"} className="section-link">
                  Terms & Conditions
                </Link>
                <Link href={"/policy"} className="section-link">
                  Privacy Policy
                </Link>
                <Link href={"/disclosure"} className="section-link">
                  Affiliate Disclosure
                </Link>
              </div>
            </div>
            <div className="desc">
              <div className="desc-title">
                Plush: Your AI-Powered Fashion Search and Discovery Destination
              </div>
              <div>
                Discover and shop women&apos;s fashion effortlessly with Plush.
                Using advanced AI and natural language search, Plush helps you
                discover exactly what you need—just ask, &quot;lightweight flowy
                maxi dress with soft pastel colors under $500 in size
                small&quot; or &quot;What can I wear to a black-tie wedding on
                the beach?&quot; Whether you&apos;re seeking specific pieces or
                inspiration for any occasion, Plush connects you to stylish
                clothing and accessories from premium brands, tailored to your
                preferences and body type. Try Plush today and discover a
                smarter, more personalized and more inspiring way to shop for
                fashion!
              </div>
            </div>
          </div>
          <div className="flex social-section">
            <Link
              href={SOCIAL_LINKS.instagram}
              className="social-icon"
              target="_blank"
            >
              <img src="/ins-white.svg" alt="instagram" />
            </Link>
            <Link
              href={SOCIAL_LINKS.tiktok}
              className="social-icon"
              target="_blank"
            >
              <img src="/tiktok-white.svg" alt="tiktok" />
            </Link>
            <Link
              href={SOCIAL_LINKS.twitter}
              className="social-icon"
              target="_blank"
            >
              <img src="/twitter-white.svg" alt="twitter" />
            </Link>
          </div>
        </div>

        <style jsx>{`
          .bottom-link-over {
            padding: 72px;
          }
          .bottom-col {
            flex-shrink: 0;
            padding-right: 64px;
          }
          .desc {
            color: #979797;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 140%; /* 22.4px */

            .desc-title {
              color: #fff;
              font-size: 16px;
              margin-bottom: 8px;
              font-weight: 600;
              line-height: 140%; /* 22.4px */
            }
          }
          .section-title {
            margin-bottom: 8px;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px;
          }
          .section-link {
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
          }
          .social-section {
            align-items: flex-end;
            flex-grow: 1;
            justify-content: flex-end;
            margin-top: 36px;

            a {
              width: 48px;
              height: 48px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          @media (max-width: 768px) {
            .top-section {
              flex-wrap: wrap;
            }
            .desc {
              margin-top: 48px;
              font-size: 15px;
              line-height: 140%; /* 16.8px */
            }
            .left-section {
              width: 100%;
            }
            .bottom-col {
              width: 50%;
              padding-right: 0;
            }
            .bottom-link-over {
              flex-direction: column;
              padding: 24px;
            }
            .policy-item {
              margin-left: 0 !important;
              margin-top: 40px;
            }
            .bottom-zone {
              height: auto;
            }
            .social-section {
              margin-top: 40px;
              margin-bottom: 30px;
            }
          }
        `}</style>
      </div>
    </>
  );
};

export default Bottom;
